import { ChangeDetectionStrategy, Component, inject, signal, ViewChild } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { NumberToCurrencyPipe } from '../../../../shared/pipes/number-to-currency.pipe';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { ITicketDetails } from '../../core/interfaces/ITicketDetails';
import { TicketsService } from '../../core/services/TicketsService';
import { ReportsService } from '../../../reports/core/services/ReportsService';
import { ReportKeys } from '../../../reports/core/enums/ReportKeys';
import { PdfViewerModalComponent } from '../../../../shared/components/pdf-viewer-modal/pdf-viewer-modal.component';
import { LocaleDatetimeFormatPipe } from '../../../../shared/pipes/locale-datetime-format.pipe';

@Component({
  selector: 'app-ticket-details-modal',
  standalone: true,
  imports: [
    LoaderComponent,
    ModalComponent,
    TranslatePipe,
    NumberToCurrencyPipe,
    PdfViewerModalComponent,
    LocaleDatetimeFormatPipe
  ],
  templateUrl: './ticket-details-modal.component.html',
  styleUrl: './ticket-details-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TicketDetailsModalComponent extends BaseModalComponent<{ ticketNr: number; }> {

  @ViewChild('pdfViewerModalComponent') pdfViewerModalComponent: PdfViewerModalComponent;

  public ticket: ITicketDetails;
  public readonly isLoading = signal(false);
  public readonly isReportGenerating = signal(false);

  private readonly _ticketsService = inject(TicketsService);
  private readonly _reportsService = inject(ReportsService);

  public override open(val: { ticketNr: number; }): void {
    super.open(val);
    this.isLoading.set(true);

    this._ticketsService.getTicketByNr(val.ticketNr)
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: res => this.ticket = res.data,
        error: ({ error }: ApiErrorResponse) => {
          this.close();
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`ticket-details-modal/notifications/${error.message}.Message`)
          );
        }
      });
  }

  public printTicketDetails(): void {
    this.isReportGenerating.set(true);

    this._reportsService.generateReport(ReportKeys.TicketInfo, this.ticket.id)
      .pipe(
        finalize(() => this.isReportGenerating.set(false))
      )
      .subscribe({
        next: res => {
          this.pdfViewerModalComponent.open({ base64Content: res.data.base64Content });
          this.close();
        },
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`generate-ticket-info/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
